import { useNavigate, useLocation } from 'react-router-dom'
import {
	EuiPageBody,
	EuiFlexGroup,
	EuiFlexItem,
	EuiSpacer,
	EuiPageTemplate,
	EuiPageSection,
} from '@equipmentshare/ds2'

import PageTitle from 'views/components/PageTitle/PageTitle'
import AddToInventoryForm from './components/AddToInventoryForm'

export type LocationState = {
	from: 'string',
}

export default function AddToInventory() {
	const navigate = useNavigate()
	const location = useLocation()
	const locationState = location.state as LocationState | undefined

	const goBack = () => navigate( locationState?.from ?? '/' )

	return (
		<EuiPageBody>
			<EuiPageTemplate style={{ minBlockSize: 'max(460px, calc(100vh - 56px))' }}>
				<EuiPageSection>
					<EuiFlexGroup>
						<EuiFlexItem grow={1} />
						<EuiFlexItem grow={2}>
							<EuiSpacer />
							<PageTitle title="Add to Inventory" />
							<EuiSpacer size="xl" />
							<AddToInventoryForm goBack={goBack} />
						</EuiFlexItem>
						<EuiFlexItem grow={1} />
					</EuiFlexGroup>
				</EuiPageSection>
			</EuiPageTemplate>
		</EuiPageBody>
	)
}
